import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Mail, MapPin, Clock, Facebook, Instagram, ShieldCheck, Lock } from "lucide-react";
import api from "@/lib/api";

export default function Footer() {
  const [social, setSocial] = useState({ facebook_url: "", instagram_url: "" });
  useEffect(() => { api.get("/settings/public").then((r) => setSocial({ facebook_url: r.data.facebook_url || "", instagram_url: r.data.instagram_url || "" })).catch(() => {}); }, []);
  return (
    <footer className="bg-[#1E1A17] text-[#E6DEC3] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src="/masaya-logo.png" alt="Masaya Hospitality Cleaning" className="h-16 w-auto mb-4 brightness-0 invert opacity-90" />
          <p className="text-sm text-[#B8AE9C] leading-relaxed">
            Upscale, hospitality-grade cleaning for homes and short-term rentals across Central Texas.
          </p>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4 text-white">Services</h4>
          <ul className="space-y-2 text-sm text-[#B8AE9C]">
            <li><Link to="/airbnb-turnover" className="hover:text-[#B87333]">Airbnb Turnover Cleaning</Link></li>
            <li><Link to="/residential" className="hover:text-[#B87333]">Residential Cleaning</Link></li>
            <li><Link to="/deep-cleaning" className="hover:text-[#B87333]">Deep Cleaning</Link></li>
            <li><Link to="/services" className="hover:text-[#B87333]">All Services & Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4 text-white">Company</h4>
          <ul className="space-y-2 text-sm text-[#B8AE9C]">
            <li><Link to="/about" className="hover:text-[#B87333]">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[#B87333]">Contact</Link></li>
            <li><Link to="/book" className="hover:text-[#B87333]">Book Now</Link></li>
            <li><Link to="/get-estimate" className="hover:text-[#B87333]">Get a Quote</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-4 text-white">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[#B8AE9C]">
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-[#B87333]" /> masayahospitality@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#B87333]" /> Austin, Pflugerville, Round Rock & nearby</li>
            <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-[#B87333]" /> America/Chicago (CT)</li>
          </ul>
          {(social.facebook_url || social.instagram_url) && (
            <div className="mt-4 flex gap-3" data-testid="footer-social">
              {social.facebook_url && <a href={social.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#B87333] transition-colors" data-testid="footer-facebook"><Facebook size={18} /></a>}
              {social.instagram_url && <a href={social.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#B87333] transition-colors" data-testid="footer-instagram"><Instagram size={18} /></a>}
            </div>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#B8AE9C]">
          <p>© {new Date().getFullYear()} Masaya Hospitality Cleaning Services, LLC. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="inline-flex items-center gap-1 text-[#B8AE9C]" data-testid="footer-stripe-secure"><Lock size={13} className="text-[#5F8F87]" /> Secure online payments processed by Stripe</span>
            <span className="inline-flex items-center gap-1 text-[#B8AE9C]" data-testid="footer-insured"><ShieldCheck size={14} className="text-[#B87333]" /> Insured</span>
            <Link to="/privacy" className="hover:text-[#B87333]" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#B87333]" data-testid="footer-terms">Terms & Conditions</Link>
            <Link to="/cancellation" className="hover:text-[#B87333]" data-testid="footer-cancellation">Cancellation Policy</Link>
            <Link to="/contact" className="hover:text-[#B87333]" data-testid="footer-contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
